import { render } from "./FixedPosition.vue?vue&type=template&id=38ac6463"
import script from "./FixedPosition.vue?vue&type=script&lang=ts"
export * from "./FixedPosition.vue?vue&type=script&lang=ts"
script.render = render

export default script